import api from '../services/api';
import { querystring } from '../utils/resposta';

const Grupo = {
  model : {administradores : []},

  create : async function (data) {
    return await api.post('grupos', data)
    .then(response=>response)
    .catch(error=>error);
  },

  sair : async function (usuario_id, grupo_id) {
    return await api.get(`grupos/sair/${usuario_id}/${grupo_id}`)
    .then(response=>response)
    .catch(error=>error);
  },

  delete : async function (grupo_id) {
    return await api.delete(`grupos/id/${grupo_id}`)
    .then(response=>response)
    .catch(error=>error);
  },

  findAll : async function (page, search, limite = 6) {
    return await api.get(`grupos/all/${page}/${limite}?search=${search}`)
    .then(response=>response)
    .catch(error=>error);
  },

  // Administrador: TODOS os grupos e subgrupos (qualquer status), com grupo pai, criador e
  // participantes. As listas do site so trazem grupos principais ativos.
  listarParaAdmin : async function (page = 1, limit = 10, filtros = {}) {
    return await api.get(`grupos/admin/lista/${page}/${limit}${querystring(filtros)}`)
    .then(response=>response)
    .catch(error=>error);
  },

  // Capa do grupo/subgrupo (administrador efetivo). O corpo E a propria midia.
  editarCapa : async function (grupo_id, midia) {
    return await api.put(`grupos/editar/foto_capa/${grupo_id}`, midia)
    .then(response=>response)
    .catch(error=>error);
  },

  removerCapa : async function (grupo_id) {
    return await api.delete(`grupos/remover/foto_capa/${grupo_id}`)
    .then(response=>response)
    .catch(error=>error);
  },

  findById : async function (grupo_id) {
    return await api.get(`grupos/id/${grupo_id}`)
    .then(response=>response)
    .catch(error=>error);
  },

  findSubgruposByGrupoId : async function (grupo_id) {
    return await api.get(`grupos/subgrupos/${grupo_id}/1/50`)
    .then(response=>response)
    .catch(error=>error);
  },


  updateAdministradores : async function (grupo_id, body) {
    return await api.put(`grupos/administradores/${grupo_id}`, body)
    .then(response=>response)
    .catch(error=>error);
  },

  aceitarSolicitacao : async function (solicitacao_id) {
    return await api.post(`grupos/aceitar/${solicitacao_id}`)
    .then(response=>response)
    .catch(error=>error);
  },

  recusarSolicitacao : async function (solicitacao_id) {
    return await api.post(`grupos/rejeitar/${solicitacao_id}`)
    .then(response=>response)
    .catch(error=>error);
  },

  getParticipantes : async function (grupo_id){
    return await api.get(`grupos/participantes/recentes/${grupo_id}/1/50`)
    .then(response=>response)
    .catch(error=>error);
  },

  getSolicitacoes : async function (grupo_id){
    return await api.get(`grupos/solicitacoes/recentes/${grupo_id}/1/50`)
    .then(response=>response)
    .catch(error=>error);
  },

  findByUsuarioId : async function (usuario_id, page, search, limite = 6) {
    return await api.get(`grupos/usuario/${usuario_id}/${page}/${limite}?search=${search}`)
    .then(response=>response)
    .catch(error=>error);
  },

  participar : async function (usuario_id, grupo_id) {
    return await api.post(`grupos/participar/${usuario_id}/${grupo_id}`)
    .then(response=>response)
    .catch(error=>error);
  },

  findSearch : async function (data) {
    return await api.get(`grupos/data/${data}/1/20`)
    .then(response=>response)
    .catch(error=>error);
  }
}

export default Grupo;
